import { useState } from 'react';
import { BetaModal } from './BetaModal';

interface AppBannerProps {
  variant?: 'inline' | 'floating';
}

export const AppBanner: React.FC<AppBannerProps> = ({ variant = 'inline' }) => {
  const [showModal, setShowModal] = useState(false);

  if (variant === 'floating') {
    return (
      <>
        <BetaModal isOpen={showModal} onClose={() => setShowModal(false)} />
        <div className="fixed bottom-4 left-4 right-4 bg-primary-600 text-white rounded-2xl p-4 shadow-lg flex items-center justify-between z-40">
          <div className="flex items-center gap-3">
            <span className="text-2xl">📖</span>
            <div>
              <p className="font-semibold text-sm">Get StoryChain App</p>
              <p className="text-xs opacity-80">Start stories & get notifications</p>
            </div>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="bg-white text-primary-600 px-4 py-2 rounded-lg font-semibold text-sm hover:bg-gray-100 transition"
          >
            Download
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <BetaModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <div className="bg-gradient-to-r from-primary-500 to-primary-600 text-white rounded-xl p-4 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-3xl">📖</span>
            <div>
              <p className="font-semibold">Want to start your own stories?</p>
              <p className="text-sm opacity-90">Download the app for full experience</p>
            </div>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="bg-white text-primary-600 px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 transition"
          >
            Get App
          </button>
        </div>
      </div>
    </>
  );
};
